import { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

export function useRouter() {
  const navigate = useNavigate();
  const router = useMemo(
    () => ({
      push: (path: string) => {
        navigate(path);
      },
      replace: (path: string) => {
        navigate(path, { replace: true });
      },
      back: () => {
        navigate(-1);
      },
      forward: () => {
        navigate(1);
      },
    }),
    [navigate]
  );

  return router;
}

export function usePathname() {
  const location = useLocation();
  return location.pathname;
}

export function useLocationParam(name: string) {
  const params = useParams();
  return params[name]!;
}
